import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

// Mapa de estados
  const shippingStatesMap = {
    'AC': 'Acre', 'AL': 'Alagoas', 'AP': 'Amapá', 'AM': 'Amazonas', 'BA': 'Bahia', 
    'CE': 'Ceará', 'DF': 'Distrito Federal', 'ES': 'Espírito Santo', 'GO': 'Goiás', 
    'MA': 'Maranhão', 'MT': 'Mato Grosso', 'MS': 'Mato Grosso do Sul', 'MG': 'Minas Gerais', 
    'PA': 'Pará', 'PB': 'Paraíba', 'PR': 'Paraná', 'PE': 'Pernambuco', 'PI': 'Piauí', 
    'RJ': 'Rio de Janeiro', 'RN': 'Rio Grande do Norte', 'RS': 'Rio Grande do Sul', 
    'RO': 'Rondônia', 'RR': 'Roraima', 'SC': 'Santa Catarina', 'SP': 'São Paulo', 
    'SE': 'Sergipe', 'TO': 'Tocantins'
  };

  // Event Delegation para funcionar com Ajax Cart
  document.addEventListener('click', function(e) {
    
    if (e.target && e.target.id === 'get-shipping-btn') {
      const btn = e.target;
      const container = btn.closest('.cart-shipping-calculator');
      const input = container.querySelector('#address_zip');
      const feedback = container.querySelector('#shipping-rates-feedback');

      const rawZip = input.value.replace(/\D/g, '');
      
      if(rawZip.length !== 8) {
        feedback.innerHTML = '<span style="color:#d32f2f;">Digite um CEP válido (8 números).</span>';
        return;
      }

      feedback.innerHTML = '<span style="color:#666;">Consultando...</span>';
      btn.disabled = true;
      btn.style.opacity = '0.7';
      const originalText = btn.innerText;
      btn.innerText = '...';

      // 1. Busca Estado no ViaCEP
      fetch(`https://viacep.com.br/ws/${rawZip}/json/`)
        .then(res => res.json())
        .then(cepData => {
          if(cepData.erro) throw new Error('CEP não encontrado.');

          const stateName = shippingStatesMap[cepData.uf] || cepData.uf;
          feedback.innerHTML = '<span style="color:#666;">Calculando valores...</span>';

          // 2. Consulta Shopify
          const shopifyUrl = `/cart/shipping_rates.json?shipping_address[zip]=${rawZip}&shipping_address[country]=Brazil&shipping_address[province]=${encodeURIComponent(stateName)}`;
          return fetch(shopifyUrl);
        })
        .then(res => res.json())
        .then(data => {
          if (data.shipping_rates && data.shipping_rates.length > 0) {
            
            // LÓGICA NOVA: Verifica se tem algum frete grátis (preço 0.00)
            const hasFreeShipping = data.shipping_rates.some(rate => parseFloat(rate.price) === 0);

            let html = '<ul style="list-style:none; padding:0; margin:0;">';

            if (hasFreeShipping) {
              // CENÁRIO 1: Tem Frete Grátis -> Mostra só mensagem bonita
              html += `
                <li style="display:flex; justify-content:space-between; align-items:center; padding: 10px 0; color: #2e7d32; font-weight: bold;">
                  <span>🎉 FRETE GRÁTIS</span>
                  <span>R$ 0,00</span>
                </li>`;
            } else {
              // CENÁRIO 2: Não tem Frete Grátis -> Lista as opções normalmente
              const rates = data.shipping_rates.sort((a, b) => a.price - b.price);
              
              rates.forEach(rate => {
                const price = parseFloat(rate.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                // Limpeza opcional de nome
                let name = rate.name.replace('Correios ', '').replace('Frenet ', ''); 

                html += `
                  <li style="display:flex; justify-content:space-between; align-items:center; padding: 8px 0; border-bottom: 1px dashed #ccc;">
                    <span style="font-size:0.6em; color:#333;">${name}</span>
                    <strong style="font-size:0.65em; color:#000;">${price}</strong>
                  </li>`;
              });
            }
            html += '</ul>';
            feedback.innerHTML = html;

          } else {
            let msg = 'Nenhuma entrega encontrada.';
            if(data.zip) msg = data.zip[0];
            feedback.innerHTML = `<span style="color:#d32f2f;">${msg}</span>`;
          }
        })
        .catch(error => {
          console.error(error);
          feedback.innerHTML = `<span style="color:#d32f2f;">${error.message || 'Erro ao calcular.'}</span>`;
        })
        .finally(() => {
          btn.disabled = false;
          btn.style.opacity = '1';
          btn.innerText = originalText;
        });
    }
  });

  // Scripts auxiliares (Input e Enter)
  document.addEventListener('input', function(e) {
    if (e.target && e.target.id === 'address_zip') {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length > 5) value = value.replace(/^(\d{5})(\d)/, '$1-$2');
      e.target.value = value;
    }
  });

  document.addEventListener('keypress', function(e) {
    if (e.target && e.target.id === 'address_zip' && e.key === 'Enter') {
      e.preventDefault();
      const btn = document.getElementById('get-shipping-btn');
      if(btn) btn.click();
    }
  });
